import React, { useState } from 'react';
import { Save, Lock } from 'lucide-react';

export default function SettingsTab() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSave = (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!newPassword) {
      setError('Please enter a new password');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    localStorage.setItem('adminPassword', newPassword);
    setMessage('Password changed successfully');
    setNewPassword('');
    setConfirmPassword('');
    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <div className="admin-settings" data-testid="settings-tab">
      <h2>Settings</h2>

      <form onSubmit={handleSave} className="admin-settings-form">
        {message && <div className="admin-success" data-testid="settings-success">{message}</div>}
        {error && <div className="admin-error" data-testid="settings-error">{error}</div>}

        <div className="settings-section">
          <h3><Lock className="h-4 w-4" /> Change Admin Password</h3>
          <p className="settings-desc">Current default password is "villa2025". Change it below.</p>
          <div className="settings-password-fields">
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="New password (min 6 chars)"
              className="admin-input"
              data-testid="new-password"
              autoComplete="new-password"
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              className="admin-input"
              data-testid="confirm-password"
              autoComplete="new-password"
            />
          </div>
        </div>

        <button type="submit" className="admin-action-btn save-settings" data-testid="save-settings-btn">
          <Save className="h-4 w-4" />
          Save Password
        </button>
      </form>
    </div>
  );
}
